<template>
  <div
    v-if="visible"
    class="row fade-in"
  >
    <div class="col-12 bag-info">
      <div
        v-for="(nextUpcoming, i) in nextDeliveries"
        :key="i"
        class="bag-info-container bag-info__border row"
      >
        <div
          v-if="isSmallViewport"
          class="col-12 bag-details bag-info__mobile-heading"
        >
          <p class="bag-details__heading">
            {{ nextUpcoming.isPurchase ? 'Ditt engångsköp' : 'Ditt Abonnemang' }}
          </p>
          <h3 class="bag-details__name">
            {{ nextUpcoming.productName }}
          </h3>
        </div>

        <div class="col bag-info__logo-container bag-info-container__col">
          <cloudinary-picture
            :url="nextUpcoming.imageUrl"
            :sizes="imageDimensions"
            :sharpen="80"
            :aspect-ratio="100"
            auto-quality="best"
            :use-picture="false"
          />
          <a
            class="bag-info__recipe-link button--white button--32"
            :href="recipeLink(nextUpcoming)"
          >
            <svgicon
              name="Cooking/Recipe"
            /> Veckans meny
          </a>
        </div>
        <div class="col  bag-info-container__col">
          <div
            v-if="!isSmallViewport"
            class="row"
          >
            <div
              class="bag-details col"
            >
              <p class="bag-details__heading">
                {{ nextUpcoming.isPurchase ? 'Ditt engångsköp' : 'Ditt Abonnemang' }}
              </p>
              <h3 class="bag-details__name">
                {{ nextUpcoming.productName }}
              </h3>
            </div>
            <div
              class="col bag-buttons-container"
            >
              <div class="bag-buttons">
                <a
                  class="button button--32 button--secondary"
                  href="/mitt-konto/matkasseabonnemang"
                >
                  Ändra abonnemang
                </a>
              </div>
            </div>
          </div>
          <template v-if="!isSmallViewport">
            <div class="row">
              <div class="col-12 bag-info__bag-detail--middle">
                <div class="row">
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      Nästa leverans
                    </div>
                    <span class="detail-value">{{ deliveryTime(nextUpcoming) }}</span>
                  </div>
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      Levereras av
                    </div>
                    <span class="detail-value">{{ nextUpcoming.storeName }}</span>
                  </div>
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      Leveranssätt
                    </div>
                    <span class="detail-value">{{ deliveryMethodText(nextUpcoming.deliveryMethod) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-noGutter">
              <div class="col-12">
                <div class="row">
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      Pris
                    </div>
                    <span class="detail-value">{{ nextUpcoming.price }}:-</span>
                  </div>
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      Betalsätt
                    </div>
                    <span class="detail-value">{{ paymentMethodText(nextUpcoming.paymentProvider) }}</span>
                  </div>
                  <div class="col bag-detail__payment">
                    <div class="detail-name">
                      {{ nextUpcoming.isPurchase ? "" : 'Nästa ' }}Betalning
                    </div>
                    <span
                      class="detail-value"
                      v-html="paymentStatusText(nextUpcoming)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="isSmallViewport"
                class="col-12 bag-buttons-container__small"
              >
                <a
                  class="button button--32 button--secondary"
                  href="/mitt-konto/matkasseabonnemang"
                >
                  Ändra abonnemang
                </a>
              </div>
            </div>
          </template>
          <!-- MOBILE -->
          <template v-if="isSmallViewport">
            <IcaAccordion
              :title="nextUpcoming.productName"
              :has-border="false"
              :has-fullbleed-content="false"
            >
              <template #heading>
                <div class="bag-detail__payment">
                  <div class="detail-name">
                    Nästa leverans
                  </div>
                  <span class="detail-value">{{ deliveryTime(nextUpcoming) }}</span>
                </div>
              </template>
              <template #content>
                <div class="row">
                  <div class="col-12 bag-info__bag-detail--middle">
                    <div class="row">
                      <div class="col bag-detail__payment">
                        <div class="detail-name">
                          Levereras av
                        </div>
                        <span class="detail-value">{{ nextUpcoming.storeName }}</span>
                      </div>
                      <div class="col bag-detail__payment">
                        <div class="detail-name">
                          Leveranssätt
                        </div>
                        <span class="detail-value">{{ deliveryMethodText(nextUpcoming.deliveryMethod) }}</span>
                      </div>
                      <div class="col bag-detail__payment">
                        <div class="detail-name">
                          Pris
                        </div>
                        <span class="detail-value">{{ nextUpcoming.price }}:-</span>
                      </div>
                      <div class="col bag-detail__payment">
                        <div class="detail-name">
                          Betalsätt
                        </div>
                        <span class="detail-value">{{ paymentMethodText(nextUpcoming.paymentProvider) }}</span>
                      </div>
                      <div class="col bag-detail__payment">
                        <div class="detail-name">
                          {{ nextUpcoming.isPurchase ? "" : 'Nästa ' }}Betalning
                        </div>
                        <span
                          class="detail-value"
                          v-html="paymentStatusText(nextUpcoming)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row-noGutter">
                  <div
                    v-if="isSmallViewport"
                    class="col-12 bag-buttons-container__small"
                  >
                    <a
                      class="button button--32 button--secondary"
                      href="/mitt-konto/matkasseabonnemang"
                    >
                      Ändra abonnemang
                    </a>
                  </div>
                </div>
              </template>
            </IcaAccordion>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '#/Illustrative/Location'
import '#/Delivery/CollectinStore'
import '#/Delivery/HomeDelivery'
import '#/Controls/Check'
import '#/Logos/ICA'
import '#/Logos/ICA-Nara'
import '#/Logos/ICA-Supermarket'
import '#/Logos/ICA-Kvantum'
import '#/Logos/ICA-Maxi-Stormarknad'
import axios from 'axios'
import { format } from 'date-fns'
import { sv } from 'date-fns/locale'
import IcaAccordion from '~/@ica/ica-molecules-vue/src/components/Accordion'
import { log } from '@/_framework/entries/logging'

export default {
  name: 'GroceryBagInfo',
  components: {
    IcaAccordion
  },
  props: {
    bags: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      imageDimensions: {
        small: {
          width: 196
        },
        medium: {
          width: 480
        },
        large: {
          width: 552
        }
      },
      nextDeliveries: [],
    }
  },
  computed: {
    visible () {
      return this.bags && this.bags.groups && this.bags.groups.length > 0 && this.nextDeliveries.length > 0
    },
    isSmallViewport () {
      return this.$root.isSmallViewport
    }
  },
  watch: {
    bags (bags, oldBags) {
      if(!!bags?.groups && bags?.groups?.length !== oldBags?.groups?.length) {
        this.fetchDeliveries()
      }
    }
  },
  methods: {
    fetchDeliveries () {
      if(this.$root.isLoggedIn) {
        axios.get(`${this.$root.envConfig.baseUrl}/api/grocerybag/customer/deliveries/next?Weeks=8`)
          .then(res => {
            this.loadData(res.data)
            })
          .catch((error) => {
            if(error.response.status === 404) {
                return
              } else {
                log(`fetchDeliveries error: ${error.response.status} ${error.response.message}`)
              }
          })
        }
    },
    loadData (data) {
      const dateSortedNextDeliveries = data.nextDeliveries.sort(function compare (a, b) {
        const dateA = new Date(a.deliveryDate)
        const dateB = new Date(b.deliveryDate)
        return dateA - dateB
      })
      const bookedDeliveries = dateSortedNextDeliveries.filter((d) => d.status.toLowerCase() !== 'notstarted' && d.status.toLowerCase() !== 'cancelled' && d.status.toLowerCase() !== 'frozen' && d.status.toLowerCase() !== 'halt')
      const nextSubscription = bookedDeliveries.find(d => d.isPurchase === false)
      const nextPurchase = bookedDeliveries.find(d => d.isPurchase === true)
      const deliveriesToShow = [nextSubscription, nextPurchase].filter(Boolean)

      if(deliveriesToShow.length > 0) {
        const mappedNextDelivery = deliveriesToShow.map((delivery) => {
          const matchingBag = this.bags.groups.find(
            g => g.products.filter(
              p => p.id === delivery.productId).length > 0)
          return {
            ...delivery, product: matchingBag.products[0], link: matchingBag.link, imageUrl: matchingBag.imageUrl
            }
        })
        this.nextDeliveries = mappedNextDelivery
      }
    },
    deliveryMethodText (deliveryMethod) {
      switch (deliveryMethod.toLowerCase()) {
        case 'pickup':
          return 'Hämta i butik'
        case 'homedelivery':
          return 'Hemleverans'
        default:
          return ""
      }
    },
    paymentMethodText (paymentProvider) {
      return paymentProvider === "Store" ? "Betala i Butik" : "Förskottsbetalning"
    },
    paymentStatusText (nextUpcoming) {
      const failedPaymentText = 'Misslyckad betalning. <a href="/mitt-konto/leveranser">Vänligen uppdatera dina betaluppgifter.</a>'
      const payInStoreText = 'Betala i butik när du hämtar din matkasse.'
      const paidOnlineText =  `Summan kommer reserveras på angivet kort torsdagen innan leverans.`
      return nextUpcoming.paymentStatus === 'Failed' ?
           failedPaymentText :
              nextUpcoming.paymentMethod === "Store" ?
                payInStoreText :
                paidOnlineText

    },
    deliveryTime (delivery) {
      const date = new Date(delivery.deliveryDate)
      let deliveryTime = ""
      if(delivery.deliverySlot) {
        const fromTimeDate = new Date(delivery.deliveryDate)
        fromTimeDate.setHours(delivery.deliverySlot.from.hour)
        fromTimeDate.setMinutes(delivery.deliverySlot.from.minute)
        const toTimeDate = new Date(delivery.deliveryDate)
        toTimeDate.setHours(delivery.deliverySlot.to.hour)
        toTimeDate.setMinutes(delivery.deliverySlot.to.minute)
        deliveryTime =  `mellan ${format(new Date(fromTimeDate), 'H:mm')} - ${format(new Date(toTimeDate), 'H:mm')}`
      }
      return `${format(new Date(date), 'dd MMMM', {
              locale: sv
              })} ${deliveryTime}`
    },
    recipeLink (upcomingDelivery) {
      const deliveryProduct = upcomingDelivery.product
      if(deliveryProduct) {
        let realLink = upcomingDelivery.link
        const qs = {}
        if (deliveryProduct.peoples) {qs.p = deliveryProduct.peoples}
        if (deliveryProduct.days) {qs.d = deliveryProduct.days}
        if (deliveryProduct.glutenFree) {qs.g = deliveryProduct.glutenFree}
        if (deliveryProduct.lactoseFree) {qs.l = deliveryProduct.lactoseFree}

        if (qs.p || qs.d || qs.g || qs.l) {
          const query = Object.keys(qs)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(qs[k]))
            .join('&')

          realLink = `${realLink}?${query}`
        }
        return realLink
      } else {
        return upcomingDelivery.link
      }
    },
  },
}
</script>

<style lang="scss">
.bag-info {
  &__border {
    border: 1px solid $color-grey-special;
    box-shadow: $box-shadow-primary;
    border-radius: 0.25rem;

    &[class~="row"],
    [class*="row-"],
    [class*="row_"] {
      margin-bottom: 0.5rem;
    }
  }

  &-container {
    background: $color-white;

    .bag-info__logo-container {
      position: relative;
      display: flex;
      flex-grow: 0;
      padding: 1.5rem 1rem 1.5rem 1.5rem;

      .bag-info__recipe-link {
        position: absolute;
        bottom: 1rem;
        left: 1.5rem;

        svg {
          width: 1.25rem;
          height: 1.25rem;
        }

        @include media-breakpoint-up(md) {
          bottom: 2.375rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      .epi-picture {
        width: 100%;
        height: 10rem;

        @include media-breakpoint-up(md) {
          width: 12.25rem;
          height: 12.25rem;

          .epi-background-container {
            border-radius: 0.25rem;
            height: 100%;
          }
        }
      }
    }

    .bag-info__mobile-heading {
      padding: 1rem 1.5rem 0 1.5rem;
    }

    .bag-detail__payment {
      flex-grow: 0;
      padding: 0 1rem;

      .detail-name {
        @include font(text, 2, "black");

        text-transform: uppercase;
        margin-bottom: 0.5rem;

        @include media-breakpoint-up(md) {
          white-space: nowrap;
        }
      }

      .detail-value {
        @include media-breakpoint-up(md) {
          white-space: nowrap;
        }
      }

      @include media-breakpoint-down(sm) {
        max-width: 100%;
        flex-basis: 100%;
        padding: 0 1rem 1rem 1rem;
      }

      &:first-child {
        @include media-breakpoint-up(md) {
          padding-left: 0.5rem;
        }
      }
    }

    .bag-info-container__col {
      padding: 1.5rem 1.5rem 1.5rem 1rem;

      @include media-breakpoint-down(sm) {
        max-width: 100%;
        flex-basis: 100%;
        padding: 1.5rem 0 0 0;
      }

      .accordion-block {
        box-shadow: none;
      }

      .accordion-block__heading {
        padding: 0 0.5rem 0 0.5rem;

        .detail-name {
          @include font(text, 2, "black");

          color: $color-grey-dark;
        }

        .detail-value {
          @include font(text, 3, "normal");

          color: $color-grey-dark;
        }
      }

      .accordion-block__content {
        padding: 0 1rem 1rem 1rem;
      }
    }

    .bag-info__logo-circle {
      padding: 1.25rem;
      max-width: 5.5rem;
      max-height: 5.5rem;
      background: white;
      border-radius: 50%;
      width: 100%;
      box-shadow: 0 0.25rem 0.5rem 0 rgb(249, 245, 245);
      border: 1px solid $color-grey-special;
    }

    .bag-details {
      &__heading {
        @include font(text, 2);

        color: $color-red;
        font-weight: 900;
        text-transform: uppercase;
        margin-top: 0;
        margin-bottom: 0.5rem;
      }

      &__name {
        @include font(rubrik, 2, "bold");

        margin: 0;
      }

      &__store-name {
        color: $color-red;
      }
    }

    .bag-buttons-container {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;

      .bag-buttons {
        padding: 0 0.5rem;
      }

      a {
        float: right;
        margin: 0 0.5rem 0.5rem 0.5rem;
      }
    }

    .bag-buttons-container__small {
      a {
        display: block;
      }
    }
  }

  .store-delivery-wrapper__details-item {
    white-space: nowrap;
  }

  .bag-info__bag-detail--middle {
    padding-bottom: 0;

    @include media-breakpoint-up(md) {
      padding-bottom: 1rem;
    }
  }
}
</style>
